import { languageSchema } from "./languageSchema";

export const getTicketsSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number" },
      limit: { type: "number" },
      checkedIn: { type: "boolean" },
      tagMatch: { type: "string", enum: ["all", "any"] },
      searchByName: { type: "boolean" },
      ...languageSchema.properties,
    },
    required: ["eventId"],
  },
};

export const getTicketByIdSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
      eventId: { type: "number" },
    },
  },
};

export const getTicketBySecretCodeSchema = {
  params: {
    type: "object",
    properties: {
      secretCode: { type: "string" },
    },
    required: ["secretCode"],
  },
};

export const createTicketSchema = {
  body: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      userData: {
        type: "object",
        properties: {
          firstName: { type: "string", minLength: 1 },
          lastName: { type: "string", minLength: 1 },
          email: { type: "string", minLength: 1 },
          categoryOfUser: { type: "array", items: { type: "number" } },
        },
        required: ["firstName", "lastName", "email"],
      },
    },
    required: ["eventId", "userData"],
  },
};

export const patchTicketSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
  },
  body: {
    type: "object",
    properties: {
      checkedInAt: { type: ["string", "null"], format: "date-time" },
      checkInMethod: { type: "string", enum: ["scan", "hand"] },
      categoryOfUser: { type: "array", items: { type: "number" } },
      customFields: { type: "object" },

      // NOTE: This is a temporary field to change the email of the user
      // associated with the ticket.
      email: { type: "string" },
    },
    additionalProperties: false,
  },
};

const ticketsImportFileSchema = {
  type: "object",
  properties: {
    data: { type: "string" },
    name: { type: "string" },
    type: {
      type: "string",
      enum: [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ],
    },
  },
  required: ["data", "name", "type"],
};

export const createTicketsImportSchema = {
  body: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      file: ticketsImportFileSchema,
      tagResolution: { type: "string", enum: ["skip", "create"] },
    },
    required: ["eventId", "file"],
  },
};

export const validateTicketsImportSchema = {
  body: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      file: ticketsImportFileSchema,
    },
    required: ["eventId", "file"],
  },
};

export const getUserTicketsByEventSchema = {
  params: {
    type: "object",
    properties: {
      userId: { type: "number" },
      eventId: { type: "number" },
    },
    required: ["userId", "eventId"],
  },
};

export const getTicketRegisterHistorySchema = {
  querystring: {
    type: "object",
    properties: {
      page: { type: "number" },
      limit: { type: "number" },
      eventId: { type: "number" },
    },
  },
};

export const getTicketHistorySchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number", minimum: 1 },
      limit: { type: "number", minimum: 1, maximum: 100 },
      types: { type: "string" },
      search: { type: "string" },
    },
    required: ["eventId"],
  },
};

export const getTicketHistoryByIdSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};

export const getTicketRegisterSummarySchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const deleteTicketSchema = {
  body: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};

export const getTicketColumnsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
  },
  required: ["eventId"],
};

export const patchTicketColumnsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
  },
  body: {
    type: "object",
    properties: {
      columns: {
        type: "array",
        items: {
          type: "object",
          properties: {
            name: { type: "string" },
            isVisible: { type: "boolean" },
          },
          required: ["name", "isVisible"],
        },
      },
    },
    required: ["columns"],
  },
};

export const createTicketCustomColumnsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
  },
  body: {
    type: "object",
    properties: {
      columns: {
        type: "array",
        items: {
          type: "object",
          properties: {
            name: { type: "string", minLength: 1 },
          },
          required: ["name"],
        },
      },
    },
    required: ["columns"],
  },
};

export const getTicketCustomColumnsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
  },
  querystring: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
    },
  },
  required: ["eventId"],
};

export const patchTicketCustomColumnsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
  body: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
      data: {
        type: "object",
      },
    },
    required: ["ticketId", "data"],
  },
};

export const getExportTicketsSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const web_createTicketSchema = {
  type: "object",
  properties: {
    firstName: { type: "string", minLength: 1 },
    lastName: { type: "string", minLength: 1 },
    email: { type: "string", minLength: 1, format: "email" },
    categoryOfUser: { type: "array", items: { type: "number" } },
  },
  required: ["firstName", "lastName", "email", "categoryOfUser"],
};

export const web_checkInAttendeeSchema = {
  type: "object",
  properties: {
    firstName: { type: "string" },
    lastName: { type: "string" },
    email: { type: "string", minLength: 1, format: "email" },
    categoryOfUser: { type: "array", items: { type: "string" }, minItems: 1 },
    customFields: {
      type: "object",
      additionalProperties: { type: ["string", "null"] },
    },
  },
  required: ["firstName", "lastName", "email", "categoryOfUser"],
};
